import React, { useState } from "react";
import "../../css/main.css";
import { login } from "../../services/auth";
import Cookies from "universal-cookie";
import { t } from "i18next";

const cookies = new Cookies();

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isError, setError] = useState("false");

  const timestamp = new Date().getTime();
  const expire = timestamp + 60 * 60 * 24 * 1000 * 365;
  const expireDate = new Date(expire);

  async function loginWithData(e) {
    e.preventDefault();
    let loginData = { email: email, password: password };
    let userData = await login(loginData);
    console.log(userData);
    if (userData.status == "success") {
      cookies.set("userID", userData.user.id);
      cookies.set("isLogined", true);
      cookies.set("token", userData.token, {
        expires: expireDate,
      });
      setError(false);
      window.location.reload(true);
    } else {
      setError(true);
    }
  }
  return (
    <React.Fragment>
      <h4 className="text-center mb-4">{t("loginToAccount")}</h4>

      <form onSubmit={loginWithData}>
        <div className="mb-3">
          <label htmlFor="exampleInputEmail1" className="form-label">
            {t("emailAddress")}
          </label>
          <input
            type="email"
            className="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            name="email"
            required
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <div id="emailHelp" className="form-text">
            {t("emailHelp")}
          </div>
        </div>
        <div className="mb-3">
          <label htmlFor="exampleInputPassword1" className="form-label">
            {t("password")}
          </label>
          <input
            type="password"
            className="form-control"
            id="exampleInputPassword1"
            name="password"
            required
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
        </div>

        <button type="submit" className="btn btn-primary w-100 mt-4 mb-3">
          {t("submit")}
        </button>
        {isError == true && (
          <div className="col-md-4 col-sm-12 w-100 mt-2">
            <div className="alert alert-danger" role="alert">
              {t("errorMessage")}
            </div>
          </div>
        )}
      </form>
    </React.Fragment>
  );
}
